import s from './style.module.scss'

const Agreement = (props) => {
  console.log(props)
  return (
    <div className={s.pageContainer}>
      <p className={s.paragraph}>基于平台的隐私政策，现额外征得您对以下内容的同意，如您不点选即表示不同意，但不会影响您浏览本页面的内容。</p>
      <p className={s.paragraph}>同意博鳌医学将我在“《手术电子杂志》联名征稿”活动专区中投递的手术视频稿件和稿件作者个人姓名、医院、职称、科室、手机号码，提供给《手术电子杂志》，用于审稿和/或发表，用于投稿意向的随访，了解用户反馈意见。</p>
      <p className={s.paragraph}>除上述声明内容外，博鳌医学不会将您的上述信息用于其他授权范围外的目的。您有权随时撤销该同意，您可以联系博鳌医学official@baoeth.com行使您撤销同意的权利，博鳌医学将在收到您的通知后15个工作日内处理您的要求。</p>
    </div>
  )
}

export default Agreement
